import img from '../img/LOGOSeide.png';      
import React from 'react'

 function Imagen() {
  return (
    <div>
          <img src={img} width="80" height="80" /> 
    </div>
  )
}
export default Imagen;